import { useRef } from 'react';

import {
	Box,
	DotsHorizontalOutline,
	IconButton,
	PlusOutline,
	Popover,
	PopoverContent,
	PopoverTrigger,
	Portal,
	rem,
	useBreakpointValue,
	useDisclosure,
} from '@bonusly/design-system';

interface CollapsedButtonsProps {
	buttons: any[]; // Should we use a type here?
}

export const CollapsedButtons = ({ buttons }: CollapsedButtonsProps) => {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const isMobile = useBreakpointValue({ base: true, sm: false });
	const contentRef = useRef<HTMLDivElement>(null);

	return (
		<Popover isLazy={false} isOpen={isOpen} onClose={onClose} placement="top-start">
			<PopoverTrigger>
				<IconButton
					aria-label="More actions"
					icon={isMobile ? <PlusOutline /> : <DotsHorizontalOutline />}
					borderRadius={rem(10)}
					boxSize={rem(40)}
					color="info.text"
					fontSize={rem(24)}
					onClick={onOpen}
					_hover={{
						background: 'bg.canvas',
					}}
				/>
			</PopoverTrigger>

			<Portal>
				<PopoverContent width="fit-content">
					<Box p={1} ref={contentRef}>
						{buttons}
					</Box>
				</PopoverContent>
			</Portal>
		</Popover>
	);
};
